import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as dayjs from 'dayjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { CompassAPICruiseSearchService } from 'src/app/shared/api-compass/compass-api-cruise-search.service';
import { CompassAPIExcursionItineraryService } from 'src/app/shared/api-compass/compass-api-excursion-itinerary.service';
import { CruiseLineSailDate } from 'src/app/shared/models/cruise-line-sail-date.interface';
import { CruiseLine } from 'src/app/shared/models/cruise-line.interface';
import { ExcursionItinerary } from 'src/app/shared/models/excursion-itineraries.interface';
import { Itinerary } from 'src/app/shared/models/itinerary.interface';
import { ResponseMessage } from 'src/app/shared/models/response-message.interface';
import { ItineraryService } from 'src/app/shared/services/itinerary.service';

@Component({
	selector: 'app-travel-board-edit',
	templateUrl: './travel-board-edit.component.html'
})
export class TravelBoardEditComponent implements OnInit {

	public cancel: EventEmitter<any> = new EventEmitter<any>();
	public selectBoard: EventEmitter<any> = new EventEmitter<any>();
	public createBoard: EventEmitter<any> = new EventEmitter<any>();
	//public chooseBoard: EventEmitter<any> = new EventEmitter<any>();

	public productId: string;
	public board: ExcursionItinerary;

	public boardForm: FormGroup;

	public submitDisabled: boolean = true;
	public attemptedSubmit: boolean = false;
	public responseMsg: ResponseMessage;

	public cruiseLines: CruiseLine[];
	public cruiseLines$: Observable<CruiseLine[]>;
	public cruiseLineShipNames$: Observable<string[]>;
	public cruiseLineShipSailDates$: Observable<CruiseLineSailDate[]>;
	public cruiseLineShipSailDates: CruiseLineSailDate[];
	public cruiseLineId: string = '';
	public cruiseLineShipName: string = '';
	public cruiseLineShipSailDate: CruiseLineSailDate = {};
	public codeToCruiseId: string = '';

	public initCruiseLineName: string = '';
	public initCruiseLineShipName: string = '';
	public initCodeToCruiseId: string = '';

	public itinerary: Itinerary = null;

	constructor(
		private _compassAPICruiseSearchService: CompassAPICruiseSearchService,
		private _compassAPIExcursionItineraryService: CompassAPIExcursionItineraryService,
		private formBuilder: FormBuilder,
		private _itineraryService: ItineraryService,
		public modalService: BsModalService,
		private modalRef: BsModalRef,
		private router: Router,
	) { }

	ngOnInit(): void {
		// console.log('TravelBoardEditComponent.productId:', this.productId);
		// console.log('TravelBoardEditComponent.board:', this.board);

		this.itinerary = this._itineraryService.getItinerary();
		//console.log('TravelBoardEditComponent.itinerary:', this.itinerary);


		this.initForm(this.board);

		this.cruiseLines$ = this._compassAPICruiseSearchService.getCruiseLines()
			.pipe(map((data) => {
				//console.log('getCruiseLines.data:', data);
				this.cruiseLines = data;
				this.checkCruiseData();
				return data;
			}));

		if(this.itinerary && !this.board?.cruiseInformation) {
			const itinerarySailDate = this.itinerary.sailDate,
				isFutureDate = dayjs().diff(dayjs(itinerarySailDate), 'day') <= 0;
				//console.log('isFutureDate:', isFutureDate, itinerarySailDate); 
			if(isFutureDate) {
				this.cruiseLineId = this.itinerary.cruiseLineId;
				this.initCruiseLineName = this.itinerary.cruiseLineName;
				this.initCruiseLineShipName = this.itinerary.shipName;
				this.initCodeToCruiseId = this.itinerary.codeToCruiseId;
				// console.log('initCruiseLineName:', this.initCruiseLineName);
				// console.log('initCruiseLineShipName:', this.initCruiseLineShipName);
				//console.log('initCodeToCruiseId:', this.initCodeToCruiseId);
				this.getCruiseLineShipNames();
			}

		}
		

	}



	/**
	 * get Cruise Line Ship Names
	*/
	public getCruiseLineShipNames(){
		//console.log('getCruiseLineShipNames', this.cruiseLineId);
		//if(this.cruiseLineId == '') {
			this.cruiseLineShipName = '';
		//}
		this.codeToCruiseId = '';

		this.cruiseLineShipNames$ = this._compassAPICruiseSearchService.getCruiseLineShipNames(this.cruiseLineId)
			.pipe(map((data) => {
				//console.log('getCruiseLineShipNames.data:', data);
				if(this.initCruiseLineShipName) {
					this.cruiseLineShipName = this.initCruiseLineShipName;
					this.initCruiseLineShipName = null;
					this.getCruiseLineShipSailDates();
				}
				return data;
			}));

	}

	/**
	 * get Cruise Line Ship Sail DAtes
	*/
	public getCruiseLineShipSailDates(){
		//console.log('getCruiseLineShipSailDates', this.cruiseLineId, this.cruiseLineShipName);
		if(this.cruiseLineId == '' || this.cruiseLineShipName == '') {
			this.codeToCruiseId = '';
		}

		const searchAllDates = this.board?.id ? false : true;

		this.cruiseLineShipSailDates$ = this._compassAPICruiseSearchService.getCruiseLineShipSailDates(this.cruiseLineId, this.cruiseLineShipName, searchAllDates)
			.pipe(map((data: CruiseLineSailDate[]) => {
				//console.log('getCruiseLineShipSailDates.data:', data);
				this.cruiseLineShipSailDates = data;
				//this.cruiseLineShipSailDates = this.checkFilteredData(data);

				if(this.initCodeToCruiseId) {
					this.codeToCruiseId = this.initCodeToCruiseId;
					this.initCodeToCruiseId = null;
				}
				return data;
			}));

	}



	// /**
	//  * Check data and filter by date if NEW board, else return all dates
	//  * @param data 
	//  * @returns 
	// */
	// public checkFilteredData (data: CruiseLineSailDate[]) {
	// 	// console.log('checkFilteredData.data:', data);
	// 	// console.log('checkFilteredData.board:', this.board);

	// 	let filteredData = data;
	// 	if(!this.board.id) {
	// 		//console.log('checkFilteredData no board id, filter dates to start with today');
	// 		filteredData = this._compassAPICruiseSearchService.filterSailDates(data);
	// 	}

	// 	return filteredData;
	// }





	public initForm(data: ExcursionItinerary = null) {
		//console.log('initForm.data:', data);
		if(!data){
			data = {
				//id: '',
				name: ''
			}
		}

		this.boardForm = this.formBuilder.group({
			id:  [data.id, []],
			name:  [data.name, [Validators.required]],
		});

	}

	public checkCruiseData () {
		if(this.board?.cruiseInformation && this.board.cruiseInformation.codeToCruiseId > 0) {
			const cruiseLine = this.cruiseLines.find(item => item.cruiseLineName == this.board.cruiseInformation.cruiseLine);
			//console.log('cruiseLine:', cruiseLine);

			this.cruiseLineId = cruiseLine.cruiseLineId;
			this.initCruiseLineShipName = this.board.cruiseInformation.shipName;
			this.initCodeToCruiseId = String(this.board.cruiseInformation.codeToCruiseId);

			this.getCruiseLineShipNames();
		}
	}


	public onSubmit() {
		//console.log('OrderComponent.onSubmit');

		this.submitDisabled = true;

		this.attemptedSubmit = true;

		this.responseMsg = {status: 'Validating Form.'};

		let updatedBoard: ExcursionItinerary = this.board ? JSON.parse(JSON.stringify(this.board)) : {};//clone board
		updatedBoard.name = this.boardForm.get('name').value;

		if(this.productId != undefined && this.productId != null) {
			if(!updatedBoard.products) updatedBoard.products = [];
			let product: any = {productId: this.productId};
			if(this.board?.id) product.excursionItineraryId = this.board.id;//API will auto-add upon creation if NEW board
			updatedBoard.products.push(product);
		}

		if(this.cruiseLineId != '' && this.cruiseLineShipName != '' && this.codeToCruiseId != '') {
			const cruiseLine = this.cruiseLines.find(item => item.cruiseLineId == this.cruiseLineId);
			this.cruiseLineShipSailDate = this.cruiseLineShipSailDates.find(sditem => String(sditem.codeToCruiseId) == this.codeToCruiseId);
			// console.log('TravelBoardComponent.cruiseLineShipSailDate:', this.cruiseLineShipSailDate);
			// console.log('TravelBoardComponent.codeToCruiseId:', this.codeToCruiseId);

			updatedBoard.cruiseInformation = {
				//cruiseLineId: this.cruiseLineId,
				cruiseLine: cruiseLine.cruiseLineName,
				shipName: this.cruiseLineShipName,
				departureDate: String(this.cruiseLineShipSailDate.sailDate),
				codeToCruiseId: Number(this.codeToCruiseId),
			}
		} else {
			//if(updatedBoard.cruiseInformation) delete updatedBoard.cruiseInformation;
			updatedBoard.cruiseInformation = null;
		}

		//console.log('TravelBoardComponent.updatedBoard:', updatedBoard);

		//return;

		if(this.board?.id) {
			this._compassAPIExcursionItineraryService.putExcursionItineraries(this.board.id, updatedBoard)
				.pipe(first())
				.subscribe((res: any) => {
					//console.log('TravelBoardComponent.putExcursionItineraries.res', res);
					if(!res.error) {
						//do something
						this.responseMsg = {success: 'Travel Board updated.'};
						setTimeout(() => {
							this.modalRef?.hide();
						}, 300);

						
					}
				});
		} else {
			this._compassAPIExcursionItineraryService.postExcursionItineraries(updatedBoard)
				.pipe(first())
				.subscribe((res: any) => {
					//console.log('TravelBoardComponent.postExcursionItineraries.res', res);
					if(!res.error) {
						//do something
						this.responseMsg = {success: 'Travel Board created.'};
						setTimeout(() => {
							this.modalRef?.hide();
							//account/my-travel-boards/0a4ae4dc-61fb-4a5d-9615-08daa734e5a1
							this.router.navigate(['/account/my-travel-boards/' + res.id]);
						}, 300);

						
					}
				});
		}



	}

	public closeModal() {
		this.cancel.emit();
		this.modalRef?.hide();
	}

}
